//import firebase from 'firebase/app';
//import 'firebase/functions';
//import 'firebase/storage';
//import Compressor from 'compressorjs'; // for compressing image size before upload

import parentUserService from '@/app-template/lib/services/UserService';

export default {
  ...parentUserService,
}